import { produce } from "immer";
import {
  // ONE TIME VERIFICATION
  ACCOUNT_ACTIVATE,
  ACCOUNT_ACTIVATE_FAILURE,
  ACCOUNT_ACTIVATE_SUCCESS,
  ACTIVATE_USER,
  ACTIVATE_USER_FAILURE,
  ACTIVATE_USER_SUCCESS,
  CHECK,
  CHECK_FAILURE,
  CHECK_SUCCESS,
  DOWNLOAD_FILE,
  DOWNLOAD_FILE_FAILURE,
  DOWNLOAD_FILE_SUCCESS,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  GOOGLE_INITIALIZED,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_FAILURE,
  LOGOUT_SUCCESS,
  // SUSPEND/ACTIVATE USER
  REGISTER_ACCOUNT,
  REGISTER_ACCOUNT_FAILURE,
  REGISTER_ACCOUNT_SUCCESS,
  REGISTER_SAGA,
  RESET_PASSWORD,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_SUCCESS,
  RESET_UPDATE_PASSWORD,
  SENT_RESET_PASSWORD_FAILURE,
  SENT_RESET_PASSWORD_PENDING,
  // password
  SENT_RESET_PASSWORD_SUCCESS,
  UDPATE_PASSWORD_SUCCESS,
  // ONE TIME VERIFICATION PASSWORD
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_FAILURE,
  VERIFY_OTP,
  VERIFY_OTP_FAILURE,
  VERIFY_OTP_SUCCESS,
  // TWO FACTOR AUTHENTICATION
  VERIFY_2FA,
  VERIFY_2FA_SUCCESS,
  VERIFY_2FA_FAILURE,
  RESEND_2FA,
  RESEND_2FA_SUCCESS,
  RESEND_2FA_FAILURE,
  SHOW_2FA_SCREEN,
  HIDE_2FA_SCREEN,
} from "./constants";

export const initialState = {
  isSagaRegistered: false,
  isLoggingIn: false,
  isAuthenticating: false,
  isLoggingOut: false,
  user: null,
  token: null,
  isAuthenticated: false,
  error: null,
  permissions: ["NO ACCESS", "READ", "DISPLAY", "WRITE", "ADMIN"],
  googleRef: null,
  isResetPassword: false,
  // ONE TIME VERIFICATION
  verifyEmailData: {},
  // ONE TIME VERIFICATION PASSWORD
  isUpdatingPassword: false,
  updatingPasswordData: {},
  // SUSPEND/ACTIVATE USER
  isActivatingUser: false,
  activeUserData: {},
  isUserActive: false,
  isActiveStep: 0,
  isVerifyingEmail: false,
  isUpdateSuccess: false,
  isRegisteringEmail: false,
  registerEmailData: {},
  isEmailRegistered: false,
  isActiveStep: 0,
  isEmailFormLoading: false,
  isVerifyingOTP: false,
  verifyOTPData: {},
  OTP: false,
  isOTPVerfied: false,
  isOTPFormLoading: false,
  isDownloadFormLoading: false,
  // FORGOT
  isSubmittingForgotPassword: false,
  // RESET
  isResetingPassword: false,
  // TWO FACTOR AUTHENTICATION
  show2FAScreen: false,
  twoFactorEmail: null,
  twoFactorRememberMe: false,
  isVerifying2FA: false,
  isResending2FA: false,
};

/* eslint-disable default-case, no-param-reassign */
const AuthReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case REGISTER_SAGA:
        draft.isSagaRegistered = true;
        break;
      case LOGIN:
        draft.isLoggingIn = true;
        draft.error = null;
        break;
      case LOGIN_SUCCESS:
        draft.isAuthenticated = true;
        draft.isLoggingIn = false;
        draft.user = action.payload.user;
        draft.token = action.payload.token;
        draft.error = null;
        break;
      case LOGIN_FAILURE:
        draft.isLoggingIn = false;
        draft.error = action.error;
        break;
      case CHECK:
        draft.isAuthenticating = true;
        break;
      case CHECK_SUCCESS:
        draft.isAuthenticated = true;
        draft.isAuthenticating = false;
        draft.user = action.payload.user;
        draft.token = action.payload.token;
        break;
      case CHECK_FAILURE:
        return initialState;
      case LOGOUT:
        draft.isLoggingOut = true;
        draft.error = null;
        break;
      case LOGOUT_SUCCESS:
        draft = initialState;
        break;
      case LOGOUT_FAILURE:
        draft.isLoggingOut = false;
        draft.error = action.error;
        break;
      case GOOGLE_INITIALIZED:
        draft.googleRef = action.payload;
        break;

      case SENT_RESET_PASSWORD_SUCCESS:
        draft.isResetPassword = false;
        break;
      case SENT_RESET_PASSWORD_FAILURE:
        draft.isResetPassword = false;
        break;
      case SENT_RESET_PASSWORD_PENDING:
        draft.isResetPassword = true;
        break;
      // ONE TIME VERIFICATION
      case ACCOUNT_ACTIVATE:
        draft.isVerifyingEmail = true;
        draft.verifyEmailData = action.payload;
        break;
      case ACCOUNT_ACTIVATE_SUCCESS:
        draft.isVerifyingEmail = false;
        draft.verifyEmailData = null;
        break;
      case ACCOUNT_ACTIVATE_FAILURE:
        draft.isVerifyingEmail = false;
        break;
      // ONE TIME VERIFICATION PASSWORD
      case UPDATE_PASSWORD:
        draft.isUpdatingPassword = true;
        draft.isUpdateSuccess = false;
        draft.updatingPasswordData = action.payload;
        break;
      case UDPATE_PASSWORD_SUCCESS:
        draft.isUpdatingPassword = false;
        draft.isUpdateSuccess = true;
        draft.updatingPasswordData = null;
        break;
      case UPDATE_PASSWORD_FAILURE:
        draft.isUpdatingPassword = false;
        break;
      case RESET_UPDATE_PASSWORD:
        draft.isUpdateSuccess = false;
        break;
      case REGISTER_ACCOUNT:
        draft.isRegisteringEmail = true;
        draft.isEmailFormLoading = true;
        draft.isEmailRegistered = false;
        draft.isActiveStep = 0;
        draft.registerEmailData = action.payload;
        draft.isOTP = false;
        break;
      case REGISTER_ACCOUNT_SUCCESS:
        draft.isRegisteringEmail = false;
        draft.isEmailFormLoading = false;
        draft.isEmailRegistered = true;
        draft.isActiveStep = 1;
        draft.isOTP = true;
        break;
      case REGISTER_ACCOUNT_FAILURE:
        draft.isEmailFormLoading = false;
        draft.isActiveStep = 0;
        draft.isRegisteringEmail = false;
        draft.isOTP = false;
        break;
      case VERIFY_OTP:
        draft.isOTPFormLoading = true;
        draft.isVerifyingOTP = true;
        draft.isActiveStep = 1;
        draft.verifyOTPData = action.payload;
        break;
      case VERIFY_OTP_SUCCESS:
        draft.isOTPFormLoading = false;
        draft.isActiveStep = 2;
        draft.isVerifyingOTP = false;
        draft.isOTPVerfied = true;
        break;
      case VERIFY_OTP_FAILURE:
        draft.isOTPFormLoading = false;
        draft.isVerifyingOTP = false;
        draft.isOTPVerfied = false;
        draft.isActiveStep = 1;
        break;
      case DOWNLOAD_FILE:
        draft.isDownloadFormLoading = true;
        draft.isVerifyingOTP = false;
        draft.isOTPVerfied = false;
        draft.isActiveStep = 2;
        break;
      case DOWNLOAD_FILE_SUCCESS:
        draft.isDownloadFormLoading = false;
        draft.isVerifyingOTP = false;
        draft.isOTPVerfied = false;
        draft.isActiveStep = 2;
        break;
      case DOWNLOAD_FILE_FAILURE:
        draft.isDownloadFormLoading = false;
        draft.isVerifyingOTP = false;
        draft.isOTPVerfied = false;
        draft.isActiveStep = 2;
        break;
      // Activate user
      case ACTIVATE_USER:
        draft.isActivatingUser = true;
        draft.activeUserData = action.payload;
        break;
      case ACTIVATE_USER_SUCCESS:
        draft.isActivatingUser = false;
        draft.activeUserData = {};
        draft.isUserActive = true;
        break;
      case ACTIVATE_USER_FAILURE:
        draft.isActivatingUser = false;
        draft.isUserActive = false;
        break;
      case FORGOT_PASSWORD:
        draft.isSubmittingForgotPassword = true;
        break;
      case FORGOT_PASSWORD_SUCCESS:
        draft.isSubmittingForgotPassword = false;
        break;
      case FORGOT_PASSWORD_FAILURE:
        draft.isSubmittingForgotPassword = false;
        break;
      case RESET_PASSWORD:
        draft.isResetingPassword = true;
        break;
      case RESET_PASSWORD_SUCCESS:
        draft.isResetingPassword = false;
        break;
      case RESET_PASSWORD_FAILURE:
        draft.isResetingPassword = false;
        break;
      // Two Factor Authentication
      case SHOW_2FA_SCREEN:
        draft.show2FAScreen = true;
        draft.twoFactorEmail = action.payload.email;
        draft.twoFactorRememberMe = action.payload.rememberMe || false;
        draft.isLoggingIn = false;
        break;
      case HIDE_2FA_SCREEN:
        draft.show2FAScreen = false;
        draft.twoFactorEmail = null;
        draft.twoFactorRememberMe = false;
        break;
      case VERIFY_2FA:
        draft.isVerifying2FA = true;
        break;
      case VERIFY_2FA_SUCCESS:
        draft.isVerifying2FA = false;
        draft.show2FAScreen = false;
        draft.isAuthenticated = true;
        draft.user = action.payload.user;
        draft.token = action.payload.token;
        draft.error = null;
        break;
      case VERIFY_2FA_FAILURE:
        draft.isVerifying2FA = false;
        draft.error = action.error;
        break;
      case RESEND_2FA:
        draft.isResending2FA = true;
        break;
      case RESEND_2FA_SUCCESS:
        draft.isResending2FA = false;
        break;
      case RESEND_2FA_FAILURE:
        draft.isResending2FA = false;
        break;
    }
  });

export default AuthReducer;
